import React from 'react'
import FacultyData from '../../Assets/JSON/MV.json'
import HS from '../../Component/HS/HS'
import FacultyList from '../../Component/ReusableCode/reusableFacultyList'
import { Grid, Typography, Box, Container } from '@mui/material'
import {
  IMAGE_BASE_PATH_COMMON,
  IMAGE_BASE_PATH_DBRAIMT,
} from '../../Config/Config'

const Faculty = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ maxWidth: '1400px', mx: 'auto' }}>
        {/* Header Section */}
        <Box sx={{ mb: 8 }}>
          <Typography component="div" sx={{ mb: 5 }}>
            <HS HS_DATA={FacultyData.HOD_Message} />
          </Typography>
        </Box>

        {/* Faculty Grid */}
        <Grid container spacing={4}>
          <FacultyList
            data={FacultyData?.FacultyData?.Faculty || []}
            baseImagePath={IMAGE_BASE_PATH_DBRAIMT}
            placeholderImagePath={
              IMAGE_BASE_PATH_COMMON + 'Placeholder_Image.jpg'
            }
            title="Faculty"
          />
        </Grid>
      </Box>
    </Container>
  )
}

export default React.memo(Faculty)
